import { defineNuxtPlugin } from 'nuxt/app';

declare global {
  interface Window { dataLayer: any[] }
}

export default defineNuxtPlugin({
  name: 'gtm',
  setup: () => {
    window.dataLayer = window.dataLayer || [];

    /** deprecated: use useTracking().dispatchTrackingEvent(...) instead */
    const gtmPush = (msg: any) => {
      window.dataLayer.push(msg);
    };

    const dataLayerReset = () => {
      window.dataLayer.push(function (this: any) {
        this.reset();
      });
    };

    const ai_prompt_user_selected_role = (selectedRoleName: string) => {
      gtmPush({
        event: 'ai_prompt_user_selected_role',
        selectedRoleName,
      });
    };

    const ai_prompt_user_copied_prompt = (selectedRoleName: string) => {
      gtmPush({
        event: 'ai_prompt_user_copied_prompt',
        selectedRoleName,
      });
    };

    const ai_prompt_user_started_over = (selectedRoleName: string) => {
      gtmPush({
        event: 'ai_prompt_user_started_over',
        selectedRoleName,
      });
    };

    const ai_prompt_user_opened_additional_settings = (selectedRoleName: string) => {
      gtmPush({
        event: 'ai_prompt_user_opened_additional_settings',
        selectedRoleName,
      });
    };

    return {
      provide: {
        gtmPush,
        dataLayerReset,

        ai_prompt_user_selected_role,
        ai_prompt_user_copied_prompt,
        ai_prompt_user_started_over,
        ai_prompt_user_opened_additional_settings,
      },
    };
  },
});